import { handleError } from 'utils/errorHandler';

import { ZopimChatClient } from './clients/zopimChatClient';
import { DEFAULT_ZENDESK_SETTINGS } from './constants/zendeskSettings';
import { initializeZendeskScript } from './initializers/zendeskScriptInitializer';
import { ZopimChatService } from './services/zopimChatService';

interface InitializeV1ScriptParams {
  integrationKey: string;
}

export const initializeV1Script = ({
  integrationKey,
}: InitializeV1ScriptParams) => {
  try {
    // Create an instance of the ZopimChatService
    const client = new ZopimChatClient();
    const service = new ZopimChatService(client);

    // Initialize the script
    initializeZendeskScript({
      service,
      initialSettings: DEFAULT_ZENDESK_SETTINGS,
      integrationKey,
    });
  } catch (error) {
    handleError(error);
  }
};
